import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'haven-ocean-freight-marketplace-linescape',
  template: require('./haven-ocean-freight-marketplace-linescape.component.html'),
  styles: [require('./../blog.component.scss'), require('./haven-ocean-freight-marketplace-linescape.component.scss')]
})
export class HavenOceanFreightMarketplaceLinescapeComponent extends BlogPage {
  title = "Linescape Streamlines Ocean Freight Marketplace - Linescape";
  description = "San Francisco technology company integrates Linescape's Schedule Data into their online marketplace";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/haven-ocean-freight-marketplace-linescape/haven-ocean-freight-marketplace-linescape.component.ts